export enum HintContext {
  EndingMeasures = "endingMeasures",
  FarHistory = "farHistory",
  RecentHistory = "recentHistory",
}
